import React from "react";

import Directory from "../../components/Directory/Directory";

import { HomePageContainer } from "./HomepageStyles";

const Homepage = () => (
  <HomePageContainer>
    <Directory />
  </HomePageContainer>
);

export default Homepage;
